import { FC } from "react"
import { COLORS } from "shared/consts"

type ArrowToRightIconProps = {
  fill?: string
}
export const ArrowToRightIcon: FC<ArrowToRightIconProps> = ({
  fill = COLORS.FG.DEFAULT
}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.4552 8.49932L8.64745 11.2925L9.35271 12.0015L13.0194 8.35381C13.1137 8.25997 13.1667 8.1324 13.1667 7.99934C13.1667 7.86628 13.1137 7.73871 13.0194 7.64487L9.35271 3.99722L8.64745 4.70617L11.4552 7.49932L2.66675 7.49932L2.66675 8.49932L11.4552 8.49932Z" fill={fill} />
  </svg>
)